<template>
  <ItemPage
    title="Cadastro da Escola"
    size="md"
    :actions="actions"
  >
    <div class="white">
      <v-tabs
        v-model="tab"
        fixed-tabs
        show-arrows
        icons-and-text
      >
        <v-tabs-slider />

        <v-tab href="#dados">
          Dados da escola
          <v-icon>mdi-account-box</v-icon>
        </v-tab>

        <v-tab href="#maintainers">
          Mantenedores
          <v-icon>mdi-account-multiple</v-icon>
        </v-tab>

        <v-tab href="#contratos">
          Contratos
          <v-icon>mdi-file-document-edit</v-icon>
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item id="dados">
          <Load
            v-if="loading"
            :loadingmsg="loadingMsg"
          />
          <v-container>
            <v-row>
              <v-col>
                <v-text-field
                  v-model="school.name"
                  label="Nome"
                  @input="verifyUpdate()"
                />
                <v-select
                  v-model="school.is_defaulting"
                  :items="itens"
                  item-text="name"
                  item-value="value"
                  label="Financeiro"
                  @input="verifyUpdate()"
                />
                <v-text-field
                  v-model="school.code"
                  label="Código"
                  @input="verifyUpdate()"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-tab-item>
        <v-tab-item id="maintainers">
          <v-container>
            <v-row>
              <v-col>
                <div
                  v-for="userMaintainer in maintainers"
                  :key="userMaintainer.id"
                  class="mt-10"
                >
                  <ShowMaintainer
                    v-if="institutionsUpdate"
                    :maintainer="userMaintainer"
                    @reload="listMaintainers"
                  />
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-tab-item>
        <v-tab-item id="contratos">
          <v-container>
            <Contracts
              :institution-id="school.id"
            />
            <!-- <template v-if="!selectedContract">
              <v-row>
                <v-col>
                  <ContractList
                    :idschool="school.id"
                    @gradeLevelGroups="setGradeLevelGroups($event)"
                    @teachingSystems="setTeachingSystems($event)"
                    @goTo="goToContract($event)"
                  />
                </v-col>
              </v-row>
            </template>
            <v-row v-else>
              <v-col>
                <v-btn
                  text
                  color="primary"
                  @click="selectedContract = false"
                >
                  <v-icon left>
                    mdi-arrow-left
                  </v-icon>
                  Escolher outro contrato
                </v-btn>
                <ShowContract
                  :contract="contract"
                  :systems="teachingSystems"
                  :gradelevelgroups="gradelevelGroups"
                />
              </v-col>
            </v-row> -->
          </v-container>
        </v-tab-item>
      </v-tabs-items>
    </div>
  </ItemPage>
</template>

<script>
import Load from '@/components/Loading.vue'
import NewContractDialog from '@/components/schools/contracts/NewContractDialog.vue'
import Contracts from '@/components/schools/contracts/Contracts.vue'
// import ContractList from '@/components/schools/contracts/List_of_Contracts.vue'
// import ShowContract from '@/components/schools/contracts/Contract.vue'
import ShowMaintainer from '@/components/schools/Maintainer.vue'
import ItemPage from '@/components/pages/ItemPage.vue'
import utils from '@/api/utils.js'
import { getTextForDisplay as getStatusName, listTypes } from '@/enums/InstitutionStatusType.js'
import AddMaintainerDialog from '@/components/AddMaintainerDialog.vue'

export default {
  components: {
    Contracts,
    Load,
    // ContractList,
    ShowMaintainer,
    // ShowContract,
    ItemPage
  },
  data () {
    return {
      institutionsUpdate: false,
      institutionsDelete: false,
      tab: 'dados',
      school: [],
      currentSchool: [],
      gradelevelGroups: [],
      teachingSystems: [],
      contracts: [],
      contract: {},
      itens: [],
      selectedContract: false,
      loading: false,
      loadingMsg: '',
      maintainer: [],
      disableUpdate: false,
      maintainers: {}
    }
  },
  computed: {
    id () {
      return this.$route.params.id
    },
    actions () {
      if (this.tab === 'maintainers') {
        return [
          {
            label: 'Adicionar Mantenedor',
            action: this.addMaintainer,
            icon: 'mdi-plus',
            disabled: !this.institutionsUpdate
          }
        ]
      }
      if (this.tab === 'contratos') {
        return [
          {
            label: 'Novo Contrato',
            action: this.openNewContractDialog,
            icon: 'mdi-plus',
            disabled: !this.institutionsUpdate
          }
        ]
      }
      return [
        {
          label: 'Salvar Alterações',
          action: this.updateSchool,
          icon: 'mdi-floppy',
          disabled: !this.disableUpdate
        },
        {
          label: 'Deletar',
          action: this.deleteInstitution,
          icon: 'mdi-delete',
          disabled: !this.institutionsDelete
        }
      ]
    }
  },
  async created () {
    await this.fetchAll()
  },
  methods: {
    async fetchAll () {
      this.institutionsUpdate = utils.checkPermissions('institutions.update-any')
      this.institutionsDelete = utils.checkPermissions('institutions.delete')
      this.itens = this.listTypes()
      await this.getSchoolId()
    },
    async getSchoolId () {
      this.loading = true
      this.loadingMsg = 'Carregando informações'
      try {
        const getSchool = await this.$api.getSchoolId(this.id)
        this.school = getSchool
        this.currentSchool = utils.currentData(getSchool)
        await this.listMaintainers()
      } catch (e) {
        this.loading = false
        this.getErrors(e.response)
      }
      this.loading = false
    },
    async listMaintainers () {
      this.loading = true
      this.loadingMsg = 'Carregando informações'
      try {
        const maintainers = await this.$api.listMaintainers(this.school.code)
        this.maintainers = maintainers
      } catch (e) {
        this.loading = false
        this.getErrors(e.response)
      }
      this.loading = false
    },

    verifyUpdate () {
      const update = utils.newData(this.school, this.currentSchool)
      if (Object.keys(update).length > 0) {
        this.disableUpdate = true
      } else {
        this.disableUpdate = false
      }
    },

    async updateSchool () {
      this.loading = true
      this.loadingMsg = 'Salvando informações'
      const data = utils.newData(this.school, this.currentSchool)
      try {
        await this.$api.updateSchool(data, this.id)
        this.getSchoolId()
        this.disableUpdate = false
      } catch {
        // console.log('Erro ao salvar informações')
      }
    },
    setGradeLevelGroups (data) {
      this.gradelevelGroups = data
    },
    setTeachingSystems (data) {
      this.teachingSystems = data
    },

    goToContract (contract) {
      this.contract = contract
      this.selectedContract = true
    },
    async deleteInstitution () {
      this.$dialog.confirm('Apagar instituição?')
        .text('Essa ação não pode ser desfeita')
        .label('Apagar')
        .onConfirm(async () => {
          try {
            await this.$api.deleteSchool(this.id)
            this.$router.push({ name: 'escolas' })
            this.$store.dispatch('setSnackBar', { text: 'Instituição apagada com sucesso.' })
          } catch (e) {
            this.getErrors(e.response)
          }
        })
        .show()
    },

    async addMaintainer () {
      this.$dialog.custom(AddMaintainerDialog).show()
        .then(async (maintainer) => {
          if (!maintainer) {
            return
          }
          maintainer.institution_code = this.school.code
          this.loading = true
          this.loadingMsg = 'adicionando mantenedor'
          try {
            const newmaintainer = await this.$api.saveMaintainer(maintainer)
            this.$dialog.confirm('Novo Mantenedor cadastrado')
              .text(`Login: ${newmaintainer.institution_code}-${newmaintainer.login} , senha: ${newmaintainer.login}`)
              .label('ok')
              .cancelLabel('')
              .show()
            this.listMaintainers()
            this.disableUpdate = true
          } catch {
            this.$store.dispatch('setSnackBar', { text: 'Erro ao adicionar mantenedor.', color: 'red' })
          }
          this.loading = false
        })
    },

    openNewContractDialog () {
      this.$dialog.custom(NewContractDialog).with({ id: parseInt(this.id) }).show()
        .then((contract) => {
          if (!contract) {
            return
          }
          this.goToContract(contract)
        })
    },

    listTypes,
    getStatusName
  }
}
</script>
